import { ECurrency, ETableLimit } from '../../../../types/enums'

export const tableLimitsByBigBlind: Record<
  Extract<
    ECurrency,
    typeof ECurrency.TON | typeof ECurrency.USDT | typeof ECurrency.COIN
  >,
  Record<ETableLimit, number>
> = {
  [ECurrency.TON]: {
    [ETableLimit.MICRO]: 0.1,
    [ETableLimit.LOW]: 1,
    [ETableLimit.MID]: 10,
    [ETableLimit.HIGH]: Number.POSITIVE_INFINITY,
  },
  [ECurrency.USDT]: {
    [ETableLimit.MICRO]: 0.1,
    [ETableLimit.LOW]: 1,
    [ETableLimit.MID]: 10,
    [ETableLimit.HIGH]: Number.POSITIVE_INFINITY,
  },
  [ECurrency.COIN]: {
    [ETableLimit.MICRO]: 0,
    [ETableLimit.LOW]: 0,
    [ETableLimit.MID]: 100,
    [ETableLimit.HIGH]: Number.POSITIVE_INFINITY,
  },
}
